import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ApiCenter } from '../../api/ApiCenter';
import { Button, Form, Input, Popconfirm, Radio, Select } from 'antd';
import { nanoid } from 'nanoid';
import { DeleteOutlined } from '@ant-design/icons';
import classes from './style/CreatingThemeTest.module.css';
import notification, { NotificationPlacement } from 'antd/lib/notification';
import { UI_Footer } from '../../../Core/Core';
const CreatingThemeTest = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState<any>([]);
  const Apistart = new ApiCenter();
  const [form] = Form.useForm();
  const openNotification = (
    placement: NotificationPlacement,
    error: boolean,
    textEror?: string
  ) => {
    if (error) {
      notification.error({
        message: `Упс что то пошло не так (─‿‿─)♡`,
        description: textEror,
        placement,
      });
    } else {
      notification.success({
        message: `Тест Успешно создан (＠＾◡＾)`,
        placement,
      });
    }
  };
  useEffect(() => {
    const strLink = typeof id === 'string' ? 'hr/theme/' + id : 'hr/theme/';
    Apistart.GET_API(strLink, 'GET').then((response: any) => {
      if (response.success) {
        if (response.data.lessons) {
          setData([
            {
              theme_id: response.data.theme.id,
              title: response.data.theme.title,
            },
          ]);
        } else {
          setData(() => {
            const newThemesArray = response.data.themes.map((i: any) => {
              return {
                theme_id: i.id,
                title: i.title,
              };
            });
            return newThemesArray;
          });
        }
      }
    });
  }, [id]);

  const onFinish = (values: any) => {
    const ReturnData = {
      title: values?.title,
      theme_id: values?.theme_id,
      questions: values?.questions?.map((value: any) => {
        const is_right = (str: string) => {
          if (value.questions_button === str) {
            return true;
          } else {
            return false;
          }
        };
        return {
          text: value.questions_title,
          answers: [
            { text: value.questions_1, is_right: is_right('questions_1') },
            { text: value.questions_2, is_right: is_right('questions_2') },
            { text: value.questions_3, is_right: is_right('questions_3') },
            { text: value.questions_4, is_right: is_right('questions_4') },
          ],
        };
      }),
    };
    Apistart.GET_API('hr/test', 'POST', ReturnData).then((r) => {
      if (r.success) {
        openNotification('top', false);
        console.log('object');
        navigate('/tests');
      } else {
        openNotification('top', true, r.message);
      }
    });
  };
  if (data.length === 0) {
    return <>Нет данных</>;
  }
  return (
    <>
      <Form
        form={form}
        name="CreatingThemeTest"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
      >
        <Form.Item label="Название Теста" name="title" style={{ width: 450 }}>
          <Input />
        </Form.Item>
        <Form.Item name="theme_id" label="Выбор темы для теста">
          <Select>
            {data?.map((option: any) => {
              const nanoId = nanoid();
              return (
                <Select.Option key={nanoId} value={option.theme_id}>
                  {option.title}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.List name="questions">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }, index: number) => {
                const confirmDeleteLesson = () => {
                  remove(name);
                };
                return (
                  <React.Fragment key={key}>
                    <div className={classes.WrapperLissensIndex}>
                      <div>Вопрос {index + 1}</div>
                      <div>
                        <Popconfirm
                          placement="right"
                          title={'Удалить урок ?'}
                          onConfirm={confirmDeleteLesson}
                          okText="Да удалить вопрос"
                          cancelText="Отмена"
                        >
                          <Button>
                            Удалить вопрос <DeleteOutlined />
                          </Button>
                        </Popconfirm>
                      </div>
                    </div>
                    <Form.Item
                      {...restField}
                      name={[name, 'questions_title']}
                      // rules={[{ required: true, message: 'Введите название урока' }]}
                      label="Описание вопроса"
                    >
                      <Input placeholder="Описание вопроса" />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'questions_1']}
                      // rules={[{ required: true, message: 'Введите название урока' }]}
                      label="Варианты ответов"
                    >
                      <Input.TextArea placeholder="Вариант ответа" />
                    </Form.Item>{' '}
                    <Form.Item
                      {...restField}
                      name={[name, 'questions_2']}
                      // rules={[{ required: true, message: 'Введите название урока' }]}
                    >
                      <Input.TextArea placeholder="Вариант ответа" />
                    </Form.Item>{' '}
                    <Form.Item
                      {...restField}
                      name={[name, 'questions_3']}
                      // rules={[{ required: true, message: 'Введите название урока' }]}
                    >
                      <Input.TextArea placeholder="Вариант ответа" />
                    </Form.Item>{' '}
                    <Form.Item
                      {...restField}
                      name={[name, 'questions_4']}
                      // rules={[{ required: true, message: 'Введите название урока' }]}
                    >
                      <Input.TextArea placeholder="Вариант ответа" />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'questions_button']}
                      label="Выберете правильный ответ"
                      rules={[{ required: true, message: 'Выберете правильный ответ!!!!!!!' }]}
                    >
                      <Radio.Group>
                        <Radio.Button value="questions_1">Вариант 1</Radio.Button>
                        <Radio.Button value="questions_2">Вариант 2</Radio.Button>
                        <Radio.Button value="questions_3">Вариант 3</Radio.Button>
                        <Radio.Button value="questions_4">Вариант 4</Radio.Button>
                      </Radio.Group>
                    </Form.Item>
                  </React.Fragment>
                );
              })}
              <Form.Item>
                <Button type="dashed" onClick={() => add()} block>
                  + Добавить вопрос
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
        <UI_Footer classStyle="end">
          <Form.Item style={{ margin: '0' }}>
            <Button type="primary" htmlType="submit">
              Добавить Тест
            </Button>
          </Form.Item>
        </UI_Footer>
      </Form>
    </>
  );
};

export default CreatingThemeTest;
